//Referral - Sales Routing Tab constants
export const DEAL_OWNER_TO_COMPANY_OWNER_FOR_EXISTING_PROSPECT =
  "Set Deal Owner to Company Owner";
export const DEAL_OWNER_TO_INTEGRATION_USER_FOR_EXISTING_PROSPECT =
  "Set Deal Owner to Integration User";
export const DEAL_OWNER_TO_INTEGRATION_USER_FOR_NEW_PROSPECT =
  "Set Deal Owner to Integration User";
export const DEAL_OWNER_IN_APPROVAL_WORKFLOW =
  "Manually Select Deal Owner in Approval Workflow";
